<template>
    <div>
        {{ address.firstname }}, {{ address.lastname }} <br>
        {{ address.address }} <br>
        {{ address.address_two }} <br>
        <template v-if="lineThree">{{ address.address_three }} <br></template>
        <template v-if="city">{{ address.city }} <br></template>
        <template v-if="state">{{ address.state }} <br></template>
        <template v-if="county">{{ address.county }} <br></template>
        <template v-if="country">{{ address.country.name }} <br></template>
        <template v-if="postalCode">{{ address.postal_code }}</template>

        <div class="actions">
            <template v-if="!removing">
                <a class="edit-btn" href="#" @click.prevent="edit">Edit</a>
                <div class="delete-actions">
                    <a class="text-danger" href="#" @click.prevent="confirmRemove" v-if="!pendingRemoval">Delete</a>
                    <template v-else>
                        Are you sure? &nbsp; <a href="#" class="text-danger" @click.prevent="remove">Yes</a> &middot; <a href="#" @click.prevent="cancelRemove">No</a>
                    </template>
                </div>
            </template>
            <template v-else>
                <i class="fa fa-refresh fa-spin"></i> Removing
            </template>
        </div>

        <account-address-modal
            :id="id"
            :address="address"
            :show="editing"
            @cancel="cancel"
            @saved="reset"
        ></account-address-modal>
    </div>
</template>

<script>
    import AccountAddressModal from './AccountAddressModal.vue';
    import Address from '../../Services/Account/Address.js';

    export default {
        components: {
            AccountAddressModal
        },
        props: [
            'id',
            'firstname',
            'lastname',
            'lineOne',
            'lineTwo',
            'lineThree',
            'city',
            'state',
            'county',
            'country',
            'postalCode'
        ],
        data() {
            return {
                editing: false,
                original: {},
                removing: false,
                removeConfirmed: false,
                pendingRemoval: false,
                address: {
                    firstname: this.firstname,
                    lastname: this.lastname,
                    address: this.lineOne,
                    address_two: this.lineTwo,
                    address_three: this.lineThree,
                    city: this.city,
                    county: this.county,
                    state: this.state,
                    country: this.country,
                    postal_code: this.postalCode
                }
            }
        },
        mounted() {
            this.original = JSON.parse(JSON.stringify(this.address));
        },
        methods: {
            edit() {
                this.pendingRemoval = false;
                this.editing = !this.editing
            },
            cancel() {
                this.editing = false;
                this.address = this.original;
            },
            reset() {
                this.backup = {};
                this.editing = false;
            },
            confirmRemove() {
                this.pendingRemoval = true;
            },
            cancelRemove() {
                this.pendingRemoval = false;
            },
            remove() {
                this.removing = true;
                this.pendingRemoval = false;
                Address.for(this.id).delete().then(response => {
                    this.$emit('remove', this.id);
                }).catch(error => {
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    .delete-actions {
        display:inline-block;
        margin-left:10px;
    }
    .actions {
        margin-top:1em;
    }
    .footer {
        margin-top:1em;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Account/AccountAddress.vue